export default "__VITE_ASSET__WU3WgdMR__"